import { NodeTypes } from "reactflow";
import StreamNode from "../nodes/stream-node";
import FlowNode from "../nodes/flow-node";
import Node from "../nodes/node";
import utils from "core/utils";

/**
 * Custom node types for ReactFlow
 */
export const NODE_TYPES: NodeTypes = {
    [utils.ENTITIES.SOURCE]: Node,
    [utils.ENTITIES.EXTERNALSOURCE]: Node,
    [utils.ENTITIES.TARGET]: Node,
    [utils.ENTITIES.WACTIONSTORE]: Node,
    [utils.ENTITIES.WINDOW]: Node,
    [utils.ENTITIES.CQ]: Node,
    [utils.ENTITIES.CACHE]: Node,
    [utils.ENTITIES.EXTERNALCACHE]: Node,
    [utils.ENTITIES.ROUTER]: Node,
    [utils.ENTITIES.OPENPROCESSOR]: Node,
    [utils.ENTITIES.SENTINEL]: Node,
    [utils.ENTITIES.STREAM]: StreamNode,
    [utils.ENTITIES.FLOW]: FlowNode
};

export const EdgeType = "smoothstep";

export const FormTypes = { SIDEBAR: "SIDEBAR", MODAL: "MODAL" } as const;
